import React from 'react';
import PropTypes from 'prop-types';

import './style.scss';

const Box = ({ children }) => <div className="box-container">{children}</div>;

Box.propTypes = {
  children: PropTypes.node,
};

Box.defaultProps = {};

export default Box;
